// extracted by mini-css-extract-plugin
module.exports = {"colors":"'~css/colors.css'","_steel":"#6b8089","staticValue":"input-dynamic_staticValue__8F3aG"};